module.exports = __webpack_public_path__ + "static/media/intro.cf33fa15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/introduction/assets/intro.jpg
// module id = 202
// module chunks = 0